// Import source styles
import '../scss/app.scss';

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

import { validate } from './modules/_validate.mjs';
import { navigationSlider } from "./modules/_carousels.mjs";

document.addEventListener("DOMContentLoaded", function () {
    AOS.init({startEvent: 'load', disable: 'mobile'});
    validate();
    navigationSlider();
});
